import { Grid } from '@material-ui/core';
import {
  DirectionsBike,
  DirectionsBus,
  DirectionsCar,
  Motorcycle,
  TwoWheeler,
} from '@material-ui/icons';
// import {
//   DirectionsBike as DirectionsBikeIcon,
//   DirectionsBus as DirectionsBusIcon,
//   DirectionsCar as DirectionsCarIcon,
//   Motorcycle as MotorcycleIcon,
//   TwoWheeler as TwoWheelerIcon,
// } from '@material-ui/icons';
import { getTransports } from '@webapps/business';
import { useQuery } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import BikeIcon from 'components/Icons/BikeIcon';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

const Transport = ({ info }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing, fontSizes },
  } = useStyles(styles);

  const userid = info?.id;

  const transportInfos = (value) => {
    switch (value) {
      case 'T1':
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <BikeIcon
              style={{
                marginRight: spacing(1),
                width: 20,
                fill: '#5D75A8',
                height: 20,
              }}
            />
            <div>Trottinette</div>
          </div>
        );
      case 'T2':
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <DirectionsCar
              style={{ marginRight: spacing(1), width: 20, color: '#5D75A8' }}
            />
            <div>Voiture</div>
          </div>
        );
      case 'T3':
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Motorcycle
              style={{ marginRight: spacing(1), width: 20, color: '#5D75A8' }}
            />
            <div>Scooter</div>
          </div>
        );
      case 'T4':
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <TwoWheeler
              style={{ marginRight: spacing(1), width: 20, color: '#5D75A8' }}
            />
            <div>Moto</div>
          </div>
        );
      case 'T5':
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <DirectionsBus
              style={{ marginRight: spacing(1), width: 20, color: '#5D75A8' }}
            />
            <div>Transports</div>
          </div>
        );
      case 'T6':
        return (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <DirectionsBike
              style={{ marginRight: spacing(1), width: 20, color: '#5D75A8' }}
            />
            <div>Vélo</div>
          </div>
        );
    }
  };

  const { data: transports = [], isLoading } = useQuery(getTransports, {
    key: ['moyensTransport', userid],
    variables: { id: userid },
    enabled: typeof userid !== 'undefined',
  });

  return (
    <div className={cx(classes.container)}>
      <div className={cx(global.title, classes.title)}>
        <FormattedMessage id="student.profil.transport.title" />
      </div>
      {!transports?.length ? (
        <div
          className={cx(css({
            textAlign: 'center',
            marginTop: spacing(2),
          }), global.infoText)}
        >
          <FormattedMessage id="noElements" />
        </div>
      ) : (
        <Grid
          className={css({ marginTop: spacing(0.5) })}
          container
          spacing={2}
        >
          <Grid item md={3} xs={6} style={{ padding: '0 8px', display: "flex" }}>
            {!isLoading &&
              transports?.slice(0, 6).map(({ id }, index) => (
                <div className={classes.button} key={index}>
                  {transportInfos(id)}
                </div>
              ))}
          </Grid>
        </Grid>
      )}
    </div>
  );
};

const styles = ({ fontSizes, spacing }) => ({
  container: {
    borderRadius: 10,
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    borderLeft: '3px solid #0060F9',
    lineHeight: '100%',
    paddingLeft: spacing(1),
    marginBottom: spacing(1.5),
  },
  button: {
    color: '#152652',
    textAlign: 'center',
    padding: spacing(1),
    display: 'flex',
  },
});

Transport.propTypes = {
  info: PropTypes.object,
};

export default Transport;
